export interface IEmployeeNotificationSettings {
    NotificationType: EEmployeeNotificationTypes
    SendEmailNotifications: boolean
    SendPushNotifications: boolean
    SendAppNotifications: boolean
    SendSmsNotifications: boolean
    Description: string
    MilesToJob?: number
}

export enum EEmployeeNotificationTypes {
    ScheduleReminder = 0,
    MissingInPunch = 1,
    MissingOutPunch = 2,  //it's same with Supervisor Missing Punch notification
    Timeoff = 3,
    SuspensePunch = 4,
    NewFile = 5,
    NewJobShift = 6,
    AdHocCommunication = 7,
    BadgeQualification = 8,
}